import { Heading } from '../Heading/Heading'
import { RADIO_TYPES } from './Radio.constants'
import { RadioButton } from './RadioButton'

export const RadioPresentation = () => {
  /* *** Render Radio Button *** */

  const renderRadio = () =>
    RADIO_TYPES.map(state => (
      <RadioButton
        id="id"
        label="Text"
        name="name"
        value="value"
        {...state}
        onChange={() => undefined}
      />
    ))

  return (
    <div>
      <Heading size={4}> Radio Button: </Heading>

      <div className="d-flex pt-4 justify-content-evenly">{renderRadio()}</div>
    </div>
  )
}
